// extracted by mini-css-extract-plugin
export default {"background":"BackgroundSVG_background__ZdgKg"};